import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'
import extractTextFromRichText from '../../utils/extractFromRichText'

export const registrationThemeOptions = [
  { title: 'Black (black bg, white text)', value: 'black' },
  { title: 'Red (red bg, white text)', value: 'red' },
  { title: 'White (white bg, dark text)', value: 'white' },
]

// APE-38/40: the copy + Create Account button shared by the compact block, the
// special event registration block and the Home CTA. A function, so every schema
// gets its own field definitions.
export const getRegistrationCtaFields = () => [
  defineField({
    title: 'Content',
    name: 'content',
    type: 'array',
    of: richTextContent,
    description: 'Optional. Leave empty for a button-only block.',
  }),
  defineField({
    title: 'Button label',
    name: 'buttonLabel',
    type: 'string',
    initialValue: 'Create Account',
    description:
      'Opens the Create Account form. Signed-in visitors see a My Account link instead.',
  }),
  defineField({
    title: 'Theme',
    name: 'theme',
    type: 'string',
    options: {
      list: registrationThemeOptions,
      layout: 'radio',
      direction: 'horizontal',
    },
    initialValue: 'black',
    description: 'Background & text colors.',
  }),
]

export default defineType({
  title: 'Create Account CTA',
  name: 'registrationCta',
  type: 'object',
  fields: getRegistrationCtaFields(),
  preview: {
    select: {
      content: 'content',
      buttonLabel: 'buttonLabel',
    },
    prepare({ content, buttonLabel }) {
      return {
        title: extractTextFromRichText(content) || buttonLabel || 'Create Account',
        subtitle: 'Create Account CTA',
      }
    },
  },
})
